const messages = {
  title: "Informacije o proizvodu i odobrenja",
  description:
    "Dobrodošli u sekciju brošura i cenovnika oko proizvoda Bridgestone i Firestone. Ovde možete pronaći aktuelne brošure i cenovnike za sve proizvodne oblasti i Pricat fajlove za vaše upravljanje zalihama.",
};
export default {
  messages,
};
